import services from 'src/shared/services/services';
var default_1 = /** @class */ (function () {
    function default_1() {
        this.model = [];
    }
    default_1.prototype.load = function () {
        var _this = this;
        return services.User.getAll().then(function (c) { return (_this.model = c); });
    };
    return default_1;
}());
export default default_1;



//////////////////
// WEBPACK FOOTER
// ./src/stores/UserStore.ts
// module id = 508
// module chunks = 0